module.exports = __webpack_public_path__ + "img/investments.503cee11.png";